import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import Button from '../components/Button';
import toast from 'react-hot-toast';

const CreateShopPage = () => {
  const [name, setName] = useState('');
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/shops', { name });
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Wystąpił błąd podczas tworzenia sklepu');
      console.error(err);
    }
  };

  return (
    <div className="container mx-auto">
      <h1 className="text-3xl font-bold mb-4">Stwórz Swój Sklep</h1>
      <form onSubmit={onSubmit}>
        <input
          type="text"
          name="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Nazwa sklepu"
          required
          className="input mb-2"
        />
        <Button type="submit">Stwórz Sklep</Button>
      </form>
    </div>
  );
};

export default CreateShopPage;